export default "__VITE_ASSET__NsNJuMAq__"